var inlineLink = tokens => ({
  base: {
    color: tokens.colors.neutral['90'],
    disabledColor: tokens.colors.neutral['40'],
    hover: {
      opacity: tokens.opacity['2xl']
    }
  }
});

export default inlineLink;
//# sourceMappingURL=inlineLink.js.map